import { Component } from '@angular/core';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { PermissionsService } from 'src/app/services/permissions/permissions.service'; 
import { NgComponents } from 'src/models';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent, SpinnerText } from 'src/app/services/message/message.enum';
import { MessageService } from 'src/app/services/message/message.service';
import { AimsCommonConfirmDialogComponent, AimsCommonTableHeader, AimsCommonTablePermissions, AimsCommonPopupEditorComponent } from '@aims/common-components';
import { delay, take } from 'rxjs/operators';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { GetTextPipe } from 'src/app/pipes';
import { ComponentRegistrationPopupComponent } from './component-registration-popup/component-registration-popup.component';

@Component({
    selector: 'component-registration',
    templateUrl: './component-registration.component.html',
    providers: [GetTextPipe]
})

export class ComponentRegistrationComponent {

    constructor(private transferHttp: TransferHttpService, 
        public permissionsService: PermissionsService,
        private dialog: MatDialog,
        private messageService: MessageService,
        private getTextPipe: GetTextPipe) { }

    //***************************
    // Variables
    //***************************
    canCreate = this.permissionsService.canCreate(this.permissionsService.ComponentID.GroupPermissions);
    canUpdate = this.permissionsService.canUpdate(this.permissionsService.ComponentID.GroupPermissions);
    canDelete = this.permissionsService.canDelete(this.permissionsService.ComponentID.GroupPermissions);
    permissions: AimsCommonTablePermissions = { create: false, update: this.canUpdate, delete: this.canDelete, export: false }
    components:Observable<any> = this.getComponents();

    //Columns
    componentsDataSource: NgComponents[];

    componentsColumns:AimsCommonTableHeader[] = [
        { 
            key: 'delete', 
            label: 'Delete', 
            type: 'button', 
            filter: false, 
            events: { 
                click: (element) => this.handleRowDelete(element) 
            }
        },
        { 
            key: 'edit', 
            label: 'Edit', 
            type: 'button', 
            filter: false,
            events: {
                click: (element) => this.handleRowEdit(element)
            } 
        },
        { key: 'componentId', label: 'Component ID', type: 'dynamic' },
        { key: 'component', label: 'Component Name', type: 'dynamic' },
        { key: 'description', label: 'Component Description', type: 'dynamic' },
        { key: 'parentComponentName', label: 'Parent', type: 'dynamic' }
    ];
    
    //Spinner
    spinnerText: string = this.messageService.getSpinnerText(SpinnerText.Load);
    showSpinner: boolean = true;
    
    //Event Handlers
    handleRowDelete(element){
        var message = this.messageService.getDialogMessage(DialogComponent.DeleteComponent);
        let dialogRef = this.dialog.open(AimsCommonConfirmDialogComponent,{
            data: message
        });
        dialogRef.afterClosed().subscribe(dialogResult => {
            if(dialogResult){
                this.deleteComponent(element.componentId);
            }
            dialogRef = null;
        });
    }
    handleRowEdit(element){
        const component = element as NgComponents;
        //TODO: move to a class similar to manage-users User class
        this.compToEdit = new NgComponents()
        this.compToEdit.componentId  = component.componentId;
        this.compToEdit.component = component.component;
        this.compToEdit.description = component.description;
        this.compToEdit.parentComponent = component.parentComponent;
        this.compToEdit.parentComponentId = component.parentComponentId;
        this.openPopup(this.compToEdit, false);
    }
    handleRowAdd(){
        this.compIsNew = true;
        this.componentsDataSource = [new NgComponents(), ...this.componentsDataSource];
        this.compToEdit = new NgComponents();
        this.openPopup(this.compToEdit, true);
    }
    //***************************
    // Functions
    //***************************

    compToEdit: NgComponents = undefined;
    compIsNew: boolean = false;


    openPopup(compToEdit: NgComponents, isNew:boolean){
        const dialogRef = this.dialog.open(AimsCommonPopupEditorComponent, {
            data: {
                header: 'Component',
                isNew: isNew,
                content: ComponentRegistrationPopupComponent,
                contentData: compToEdit,
            },
            disableClose: true
        })
        dialogRef.afterClosed().subscribe(dialogResult => {
        if(dialogResult){
            this.compToEdit.description = dialogResult.description;
            this.compToEdit.component = dialogResult.component;
            this.compToEdit.parentComponentId = dialogResult.parentComponentId;

            if(isNew){
                //create a new cmponent
                this.compToEdit.componentId = 0
            }
            this.saveComponent();
        }else{
            this.compToEdit = undefined;
            this.componentsDataSource = this.componentsDataSource.filter(u => u.componentId);
        }
        });
    }
    deleteComponent(componentId: number) {
        this.spinnerText = this.messageService.getSpinnerText(SpinnerText.Delete, "Component");
        this.showSpinner = true;
        
        this.permissionsService.deleteComponent(componentId).pipe(take(1)).subscribe(retVal => {
            this.components = this.getComponents();
            this.showSpinner = false
        }, error => this.showSpinner = false
        );
    }
    saveComponent() {
        this.spinnerText = this.messageService.getSpinnerText(SpinnerText.Save, "Component");
        this.showSpinner = true;

        this.permissionsService.saveComponent(this.compToEdit).pipe(take(1)).subscribe(retVal => {
            this.components = this.getComponents();
            this.compToEdit = undefined;
            this.showSpinner = false;
        },
        error => this.showSpinner = false
        );
    }

    getComponents(){
        return this.permissionsService.getComponents().pipe(
            delay(0),
            tap(components => {
                //flatten so it refreshes the table, otherwise dataSource won't see changes
                this.componentsDataSource = [...components];
                this.showSpinner = false;
            })
        )
    }
    


    //***************************
    // Init
    //***************************

    ngOnInit(): void {
    }

}
